import { Drawer, List, ListItem, Box } from "@mui/material";
import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useHistory } from "react-router-dom";
import { UserRoles, lngs } from "../Constant";
import ClaimApiService from "../adapters/xhr/ClaimApiService";
import SnackbarUtils, { SnackbarUtilsConfigurator } from "../SnackbarUtils";
import { MyThemeProvider } from "./MyThemeProvider";
import { SnackbarProvider } from "notistack";
import { MyLoadingIndicator } from "../components/my-loading-indicator/MyLoadingIndicator";
import authService from "../components/api-authorization/AuthorizeService";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { getCookie } from "../Utils";
import { useIdleTimer } from "react-idle-timer";
import { MaximumIdleTimeInMinute } from "../Constant";

export const AdminLayout = (props) => {
  const { t, i18n } = useTranslation();
  const [connection, setConnection] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const history = useHistory();

  useEffect(() => {
    i18n.changeLanguage(lngs.sv.code);
  }, []);

  useEffect(() => {
    authService.getUser().then((user) => {
      setCurrentUser(user);
    });
  }, []);

  useEffect(() => {
    const connect = new HubConnectionBuilder().withUrl("/hubs/userSession").withAutomaticReconnect().build();

    setConnection(connect);
  }, []);

  useEffect(() => {
    if (connection && currentUser) {
      connection
        .start()
        .then(() => {
          connection.on("LogoutExistingUser", (userId) => {
            checkUserLogoutCommand(userId);
          });

          connection.on("YouShouldLogoutNow", () => {
            logout();
          });

          connection.send("ShouldILogout");
        })
        .catch((error) => console.log(error));
    }
  }, [connection, currentUser]);

  const checkUserLogoutCommand = (userId) => {
    if (userId == currentUser.id) {
      logout();
    }
  };

  const logout = () => {
    connection.stop().then(() => authService.logOut());
  };

  const getFraud = async () => {
    let response = await ClaimApiService.getFraud();
    if (response.data?.exceedMaxClaimsIn24Hour || response.data?.exceedMaxClaimsDuring7Days || response.data?.exceedMaxClaimsDuring30Days) {
      SnackbarUtils.warning(t("check_fraud_report"));
    }
    if (response.data?.exceedMaxOpenClaims) {
      SnackbarUtils.warning(t("check_overview"));
    }
  };

  useEffect(() => {
    getFraud();
  }, []);

  const isOnOverviewPage = (match, location) => {
    if (location.pathname === "/" || location.pathname === "/overview" || match?.isExact === true) return true;
  };

  const onIdle = () => {
    logout();
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: MaximumIdleTimeInMinute * 60 * 1000,
    throttle: 500,
  });

  return (
    <MyThemeProvider>
      <SnackbarProvider
        SnackbarProps={{
          "aria-live": "polite",
        }}
      >
        <SnackbarUtilsConfigurator />
        <Box sx={{ display: "flex" }} flexDirection="column">
          {/* <Box marginLeft={`150px`}>
          <NavMenu />
        </Box> */}
          <Drawer variant="permanent" anchor="left" PaperProps={{ style: { width: "150px", fontSize: "1rem" } }}>
            <h4 style={{ padding: "1rem 1rem 0 1rem" }}>{t("menu")}</h4>
            <List>
              <ListItem>
                <NavLink to="/overview" isActive={isOnOverviewPage} style={{ color: "black" }} activeClassName="text-primary">
                  {t("overview")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/reports" style={{ color: "black" }} activeClassName="text-primary">
                  {t("administration")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink to="/settings" style={{ color: "black" }} activeClassName="text-primary">
                  {t("settings")}
                </NavLink>
              </ListItem>
              <ListItem hidden={authService._user?.role !== UserRoles.SuperAdmin}>
                <NavLink to="/account-management" style={{ color: "black" }} activeClassName="text-primary">
                  {t("account_management")}
                </NavLink>
              </ListItem>
              <ListItem>
                <NavLink
                  to="#"
                  style={{ color: "black" }}
                  onClick={(e) => {
                    e.preventDefault();
                    logout();
                  }}
                >
                  {t("logout")}
                </NavLink>
              </ListItem>
            </List>
          </Drawer>
          <Box component="main" marginLeft={`150px`}>
            {props.children}
          </Box>
        </Box>
      </SnackbarProvider>
      <MyLoadingIndicator />
    </MyThemeProvider>
  );
};
